import { getField, updateField } from 'vuex-map-fields'
import getUserFiltersModel from './models/userFilters'

const userFilters = {
  namespaced: true,
  state: {
    ...getUserFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      state.firstName = null
      state.lastName = null
      state.active = true
      state.securityRoles = null
    }
  }
}

export default userFilters
